var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.code)?_c('div',{staticClass:"code-wrap",class:_vm.refer},[_c('div',{staticClass:"code-title"},[_vm._v("服务券码: "+_vm._s(_vm.code))]),_c('div',{attrs:{"id":"qr-img"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }